import React from 'react';
import PropTypes from 'prop-types';

import CustomTypes from '../../../types';

import { TextStyled } from './Text.styled';

const Text = ({
  as,
  content,
  children,
  modifiers,
  ...props
}) => (
  <TextStyled as={as} modifiers={modifiers} {...props}>
    {children || content}
  </TextStyled>
);

Text.propTypes = {
  as: PropTypes.string,
  children: PropTypes.node,
  content: PropTypes.node,
  modifiers: CustomTypes.oneOrMore(['', 'micro', 'small', 'large', 'inverted']),
};

Text.defaultProps = {
  as: '',
  children: null,
  content: '',
  modifiers: '',
};

export default Text;
